<template>
  <div class="body-form">
    <Loading v-if="isLoading" />
    <Popup :message="message" v-if="isPopup" @close="() => (isPopup = false)" />
    <div style="width: 90%; margin: 30px 0;">
      <div class="menus-top">
        <span class="blue-text" @click="$router.go(-1)">Cerita Alumni</span>
        <Arrow :width="20" :height="20" direct="left" strokeColor="#7B7E8C" class="icon" />
        <span style="color: #7b7e8c">{{ name }}</span>
      </div>
      <div class="card-form-head">
        <h1>Form {{ name }}</h1>
      </div>

      <div class="tab-selector" v-if="isEdit || isWatch">
        <button
          :class="['tab', activeTab === 'id' ? 'active-tab' : '']"
          @click="activeTab = 'id'"
        >
          Bahasa Indonesia
        </button>
        <button
          :class="['tab', activeTab === 'en' ? 'active-tab' : '']"
          @click="activeTab = 'en'"
        >
          Bahasa Inggris
        </button>
      </div>

      <div v-if="activeTab === 'id'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Indonesia</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="form.title"
                class="form-input"
                placeholder="Tulis judul cerita alumni"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Caption</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Tulis caption"
                outlined
                rows="3"
                v-model="form.caption"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Date Release</p>
              <v-menu
                ref="startPicker"
                v-model="startPicker"
                :close-on-content-click="false"
                :return-value.sync="form.date_release"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date_release"
                    placeholder="12-02-2023"
                    class="form-input"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                  >
                    <template v-slot:append>
                      <Calendar
                        style="margin-top: 35%; cursor: pointer"
                      ></Calendar>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date_release"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="startPicker = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.startPicker.save(form.date_release)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="content-form">
              <p>Image</p>
              <v-file-input
                v-model="img_portfolio"
                accept="image/*"
                placeholder="Unggah Berkas Gambar"
                class="form-upload"
                prepend-icon=""
                outlined
                :disabled="isWatch"
              >
                <template
                  v-slot:prepend-inner
                  v-if="isEdit && img_portfolio == null"
                >
                  <ImageModal
                    :src="form.image_url"
                    width="76.31"
                    height="37"
                    radius="3"
                  />
                </template>
                <template v-slot:append>
                  <h5 style="margin-top: 15%; color: #2d46cf">Upload</h5>
                </template>
              </v-file-input>
              <p class="note-file">
                *Rekomendasi dimensi 327 x 462 px. ukuran file maks 1 MB
              </p>
            </div>
            <div class="content-form">
              <p>Body</p>
              <vue-editor
                v-model="form.body"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                style="height: 400px; padding-bottom: 100px"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="form.body"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'en'" class="language-section">
        <div class="cart-form">
          <v-card-title class="card-form-head-2">
            <h1>Bahasa Inggris</h1>
          </v-card-title>
          <div class="mt-5">
            <div class="content-form">
              <p>Title</p>
              <v-text-field
                :disabled="isWatch"
                outlined
                v-model="formEng.title"
                class="form-input"
                placeholder="Write alumni story title"
                dense
                clearable
              ></v-text-field>
            </div>
            <div class="content-form">
              <p>Caption</p>
              <v-textarea
                :disabled="isWatch"
                placeholder="Write caption"
                outlined
                rows="3"
                v-model="formEng.caption"
                clearable
                class="form-input"
              ></v-textarea>
            </div>
            <div class="content-form">
              <p>Body</p>
              <vue-editor
                v-model="formEng.body"
                :editorToolbar="$helpers.customToolBar()"
                class="form-input"
                style="height: 400px; padding-bottom: 100px"
                v-if="!isWatch"
              ></vue-editor>
              <div v-else class="watch-ctn">
                <div v-html="formEng.body"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="submit-box" v-if="!isWatch">
        <Button
          name="Batalkan"
          outline
          class="me-3"
          @click="$router.push('/alumni-stories')"
        />
        <Button
          :name="isEdit ? 'Simpan' : 'Simpan & Publish'"
          :width="isEdit ? '156px' : '200px'"
          @click="onSubmit"
          :disabled="!validData"
          style="background-color: #2d46cf; color: #ffffff"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/ilustration/Loading.vue";
import Button from "../../../components/Button.vue";
import ImageModal from "../../../components/ImageModal.vue";
import Popup from "@/components/others/Popup.vue";
import { VueEditor } from "vue2-editor";
import Arrow from "@/components/icons/Arrow.vue";
import Calendar from "@/components/icons/Calendar.vue";

export default {
  name: "FormAlumniStories",
  components: {
    Button,
    Loading,
    ImageModal,
    Popup,
    VueEditor,
    Arrow,
    Calendar,
  },
  computed: {
    validData() {
      return (
        this.form.title &&
        this.form.caption &&
        this.form.date_release &&
        this.form.body &&
        (this.isEdit || this.img_portfolio)
      );
    },
  },
  data() {
    return {
      id: null,
      startPicker: false,
      startPickerEng: false,
      name: "",
      isLoading: false,
      isWatch: false,
      isEdit: false,
      message: "",
      isPopup: false,
      activeTab: "id",
      form: {
        title: "",
        image_url: "",
        caption: "",
        date_release: "",
        body: "",
      },
      formEng: {
        title: "",
        image_url: "",
        caption: "",
        date_release: "",
        body: "",
      },
      img_portfolio: null,
      img_portfolio_eng: null,
      img_web_name: "",
    };
  },
  methods: {
    checkingType() {
      this.name = this.$route.meta.name;
      this.isWatch = this.$route.path.lastIndexOf("watch") >= 0;
      this.isEdit = this.$route.path.lastIndexOf("edit") >= 0;
      this.id = this.$route.params.id;
      if (!this.id) return;
      this.getAlumniStories();
    },
    async getAlumniStories() {
      this.isLoading = true;
      try {
        const resp = await this.$web_http.get("/v1/alumni-stories/" + this.id);
        const data = resp.data.data.stories;
        this.form = {
          title: data.title || "",
          image_url: data.image_url || "",
          caption: data.caption || "",
          date_release: data.date_release || "",
          body: data.body || "",
          id: data.id,
        };
        this.img_web_name = this.form.image_url
          .split("/")
          .pop()
          .replace("?view=open", "")
          .replaceAll("%20", " ");
        await this.getBilingual();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    async getBilingual() {
      try {
        const { data } = await this.$crm_http.get(
          `/v1/bilingual/record/${this.id}?table_name=alumni_stories&language_code=en`
        );
        const resp = JSON.parse(data.data.bilingual?.translated_data || "{}");
        this.formEng = {
          title: resp.title || "",
          image_url: resp.image_url || "",
          caption: resp.caption || "",
          date_release: resp.date_release || "",
          body: resp.body || "",
        };
      } catch (err) {
        console.log(err);
      }
    },
    async onSubmit() {
      this.isLoading = true;
      try {
        let imageUrl = this.form.image_url;

        if (this.img_portfolio) {
          const imageForm = new FormData();
          imageForm.append("attachment", this.img_portfolio);
          const webRes = await this.$crm_http.post("/v1/upload-file", imageForm);
          imageUrl = webRes.data.data.upload_image_response.url_w_query;
          imageForm.delete("attachment");
        }

        const payload = {
          title: this.form.title,
          image_url: imageUrl,
          caption: this.form.caption,
          date_release: this.form.date_release,
          body: this.form.body,
        };

        if (this.isEdit) {
          await this.$web_http.put("/v1/alumni-stories/" + this.form.id, payload);
          await this.onSubmitBilingual(imageUrl);
        } else {
          await this.$web_http.post("/v1/alumni-stories", payload);
        }

        setTimeout(() => {
          this.$router.push("/alumni-stories");
        }, 2000);
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to submit data.";
        this.isPopup = true;
        this.isLoading = false;
      }
    },
    async onSubmitBilingual(imageUrl) {
      const payload = {
        table_name: "alumni_stories",
        record_id: this.id,
        language_code: "en",
        translated_data: JSON.stringify({
          title: this.formEng.title,
          image_url: imageUrl,
          caption: this.formEng.caption,
          date_release: this.form.date_release,
          body: this.formEng.body,
        }),
      };
      try {
        await this.$crm_http.post("/v1/bilingual", payload);
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.checkingType();
  },
};
</script>

<style scoped>
.menus-top {
  padding-top: 10px;
  display: flex;
  font-size: 16px;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}
.card-form-head {
  display: flex;
  margin: 40px 0;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.card-form-head-2 {
  display: flex;
  margin-left: -35px;
  margin-right: -20px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid gray;
}
.card-form-head-2 h1 {
  font-weight: 700;
  font-size: 18px;
  color: #36373f;
  font-family: 'Poppins', sans-serif;
  margin: 0;
}
.tab-selector {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 50px;
}
.tab {
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  cursor: pointer;
  background-color: #f9f9f9;
}
.active-tab {
  background-color: #2d46cf;
  color: white;
  border-color: #2d46cf;
}
.body-form {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fafaf9;
  padding-bottom: 30px;
  min-height: 100vh;
}
.cart-form {
  position: relative;
  margin: 40px 0;
  border-radius: 30px;
  padding: 30px 40px;
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}
.language-section {
  margin-bottom: 30px;
}
.content-form {
  margin-top: 15px;
}
.content-form p {
  font-size: 14px;
  margin: 3px 0;
  font-weight: bold;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.form-input:focus {
  border-color: #2d46cf;
  box-shadow: 0 0 5px rgba(45, 70, 207, 0.3);
}
.form-upload .v-input__slot {
  height: 62px !important;
  background-color: #ffffff !important;
}
.form-upload .v-text-field__details {
  display: none;
}
.submit-box {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
.note-file {
  font-weight: 400;
  font-size: 12px;
  color: #b80f0a;
  margin-bottom: 20px !important;
}
.watch-ctn {
  padding: 15px;
  border-radius: 15px;
  border: 1px solid gray;
}
.blue-text {
  font-weight: bold;
  color: #162ca2;
  cursor: pointer;
}
</style>